import * as ExcelJS from 'exceljs';

function detectDelimiter(firstLine: string): "," | ";" | "\t" {
  const semi = (firstLine.match(/;/g) ?? []).length;
  const comma = (firstLine.match(/,/g) ?? []).length;
  const tab = (firstLine.match(/\t/g) ?? []).length;

  if (tab > semi && tab > comma) return "\t";
  if (semi > comma) return ";";
  return ",";
}

function parseCsv(text: string, delimiter: string): string[][] {
  const rows: string[][] = [];
  let row: string[] = [];
  let field = "";
  let inQuotes = false;

  const s = text.replace(/\r\n/g, "\n").replace(/\r/g, "\n");

  for (let i = 0; i < s.length; i++) {
    const ch = s[i];

    if (inQuotes) {
      if (ch === '"') {
        const next = s[i + 1];
        if (next === '"') {
          field += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else {
        field += ch;
      }
      continue;
    }

    if (ch === '"') {
      inQuotes = true;
      continue;
    }

    if (ch === delimiter) {
      row.push(field);
      field = "";
      continue;
    }

    if (ch === "\n") {
      row.push(field);
      field = "";
      if (row.length > 1 || (row.length === 1 && row[0].trim() !== "")) {
        rows.push(row);
      }
      row = [];
      continue;
    }

    field += ch;
  }

  row.push(field);
  if (row.length > 1 || (row.length === 1 && row[0].trim() !== "")) {
    rows.push(row);
  }

  return rows;
}

export async function csvBlobToXlsxBlob(
  csvBlob: Blob,
  options?: { sheetName?: string }
): Promise<Blob> {
  const csvTextRaw = await csvBlob.text();
  const csvText = csvTextRaw.replace(/^\uFEFF/, "");

  const firstNonEmptyLine =
    csvText.split(/\r?\n/).find((l) => l.trim().length > 0) ?? "";
  const delimiter = detectDelimiter(firstNonEmptyLine);

  const data = parseCsv(csvText, delimiter);

  const wb = new ExcelJS.Workbook();
  const sheetName = options?.sheetName?.trim() || "Rapport";
  const ws = wb.addWorksheet(sheetName);

  for (const r of data) ws.addRow(r);

  if (ws.rowCount >= 1) {
    const header = ws.getRow(1);
    header.font = {...(header.font ?? {}), bold: true};
  }
  const buffer = await wb.xlsx.writeBuffer();

  return new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
}
